exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.organization[data-v-70dbe046] {\n  position: fixed;\n  top: 44px;\n  left: 0px;\n  width: 100%;\n  z-index: 999;\n}\n.blueColor[data-v-70dbe046] {\n  color: #1989fa;\n}\n.redFont[data-v-70dbe046] {\n  color: #ee0a24;\n  font-weight: bold;\n  font-size: 16px;\n}\n.dropdownTitle .labName[data-v-70dbe046] {\n  display: inline-block;\n  max-width: 135px;\n  white-space: nowrap;\n  /* 防止文本换行 */\n  overflow: hidden;\n  /* 隐藏溢出的内容 */\n  text-overflow: ellipsis;\n  /* 用省略号表示溢出的内容 */\n}\n.dropdownTitle .totalNum[data-v-70dbe046] {\n  position: absolute;\n  top: -12px;\n  right: -14px;\n  z-index: 999;\n  width: 28px;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70dbe046","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/organizationAutoShowNum/index.vue
// module id = uUb1
// module chunks = 13